import { AssetType, BucketDataType } from '../types/bucketTypes'
import assetsApi from '../api/assets.api'
// “I added a global function called fetchBucketList and a local function named getTagData.
// Reusable function to get tag data
const getTagData = (assetData: AssetType[], selectedAsset: BucketDataType) => {
    const data = assetData.filter((asset: AssetType) => {
        if (asset.asset_id === selectedAsset.asset_id) {
            return asset.tag
        }
    })
    return data.length > 0 ? data[0].tag : null
}

// Function to fetch bucket list and return tag data
export const fetchBucketList = async (
    selectedAsset?: BucketDataType,
    refetch?: boolean
) => {
    const fetchedAssets: any = await assetsApi.getAssetList()
    const tagData = selectedAsset
        ? getTagData(fetchedAssets.data.data, selectedAsset)
        : fetchedAssets.data.data
    return { refetch: refetch, fetchedAssets: tagData }
}
